export default function SectionHeading({ title, description, align = "center", className = "" }) {
  const alignment = align === "left" ? "text-left" : "text-center";
  const descriptionWidth = align === "left" ? "" : "max-w-2xl mx-auto";

  return (
    <div className={`${alignment} ${className}`.trim()}>
      <h2 className="font-sans text-3xl md:text-4xl font-bold text-foreground mb-4">{title}</h2>
      {description ? (
        <p className={`font-body text-lg text-muted-foreground ${descriptionWidth}`.trim()}>{description}</p>
      ) : null}
    </div>
  );
}
